// A frame response with no frame in it (a Cloudflare error or challenge page,
// our empty 403 for an expired CSRF token) would leave Turbo's "Content missing"
// on screen. Tell the user and take them home instead.

export const FRAME_MISSING_REDIRECT_URL = "/home";
export const FRAME_MISSING_REDIRECT_DELAY_MS = 1500;
const FALLBACK_MESSAGE = "Something went wrong. Please try again later";

export function handleFrameMissing(event, { toast, translate, visit, schedule = setTimeout, log = console }) {
  event.preventDefault();

  // cf-ray finds the request in Cloudflare; cf-mitigated marks a challenge.
  const response = event.detail?.response;
  log.warn("Frame response had no frame to render", {
    frame: event.target?.id,
    status: response?.status,
    url: response?.url,
    cfRay: response?.headers?.get("cf-ray") || undefined,
    cfMitigated: response?.headers?.get("cf-mitigated") || undefined,
  });

  try {
    toast(translate({ error: { code: "INTERNAL" } }, FALLBACK_MESSAGE));
  } catch (err) {
    log.warn("Could not show the error toast", err);
  }
  schedule(() => visit(FRAME_MISSING_REDIRECT_URL, { action: "replace" }), FRAME_MISSING_REDIRECT_DELAY_MS);
}
